import React from 'react';

import { RadioProps } from './Radio.types';
import { RadioStyle } from './Radio.style';

export const Radio = (props: RadioProps): JSX.Element => {
  return <RadioStyle {...props} />;
};
